import { Injectable } from '@angular/core';
import { ScriptLoaderService } from '@biletix/core/services/script-loader.service';

const FANCYBOX_SCRIPT_ID = 'fancybox-script';
const FANCYBOX_SCRIPT_SRC = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js';

/**
 * Fancybox'ı yalnızca `data-fancybox` içeren bir sayfa tarayıcıda render edildikten
 * sonra yükler. Eskiden index.html'de her sayfada senkron yükleniyordu ve anasayfada
 * %85'i kullanılmıyordu. UMD paketi yüklenince `[data-fancybox]`'ı kendisi bağlar.
 */
@Injectable({
  providedIn: 'root'
})
export class FancyboxLoaderService {
  constructor(private scriptLoader: ScriptLoaderService) {}

  load(): Promise<void> {
    return this.scriptLoader.load(FANCYBOX_SCRIPT_ID, FANCYBOX_SCRIPT_SRC);
  }

  /** Galeri ilk boyama için kritik değil; ana thread boşken yükler. */
  loadWhenIdle(): void {
    this.scriptLoader.loadWhenIdle(FANCYBOX_SCRIPT_ID, FANCYBOX_SCRIPT_SRC);
  }
}
